import { render } from "./EgmUploadedList.vue?vue&type=template&id=6c6398db&scoped=true"
import script from "./EgmUploadedList.vue?vue&type=script&lang=js"
export * from "./EgmUploadedList.vue?vue&type=script&lang=js"

import "./EgmUploadedList.vue?vue&type=style&index=0&id=6c6398db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6398db"]])

export default __exports__